import loadable from '@loadable/component';

export const EmbedSearchWidgetSearchJobsPageLoadable = loadable(
  () => import('./EmbedSearchWidgetSearchJobsPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetSearchJobsPage },
);
